import { CREATE_STREAM, DESTROY_STREAM, STREAM_PROPERTY_CHANGED } from 'OPENTOK/action_types';

export const createStream = (id, object, hasAudio, hasVideo) => ({
  type: CREATE_STREAM,
  id,
  payload: {
    connectionId: object.connection.connectionId,
    object,
    hasAudio,
    hasVideo,
  },
});

export const destroyStream = (id) => ({ type: DESTROY_STREAM, id });

export const streamPropertyChanged = (id, hasAudio, hasVideo) => ({
  type: STREAM_PROPERTY_CHANGED,
  id,
  payload: {
    hasAudio,
    hasVideo,
  },
});
